import { ChangeDetectionStrategy, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentService } from '@app/shared/services';
import * as moment from 'moment';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

import { Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
  selector: 'template-active-conformation-popup',
  templateUrl: './template-active-conformation-popup.component.html',
  styleUrl: './template-active-conformation-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateActiveConformationPopupComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TemplateActiveConformationPopupComponent>,
    private documentService: DocumentService,
    private fb: FormBuilder
  ) {}

  deactivedate: any;
  moment = moment;
  connectionForm: FormGroup;
  subscription = new Subscription();

  today = new Date();
  ngOnInit(): void {
    this.connectionForm = this.fb.group({
      deactiveDate: '',
    });
  }

  setDate(e) {
    this.connectionForm.controls['deactiveDate'].setValue(this.moment(e).format('MMM DD, YYYY'));
    this.connectionForm.controls['deactiveDate'].updateValueAndValidity();
  }

  cancel() {
    this.dialogRef.close({ data: 'you cancelled' });
  }

  confirm() {
    let declaredDate: any;
    if (this.data.isActive == true) {
      declaredDate = '';
    } else {
      declaredDate = moment(this.connectionForm.controls['deactiveDate'].value).format('YYYY-MM-DD');
    }
    let request = {
      id: this.data.currentFormId,
      date: declaredDate,
    };
    this.subscription.add(
      this.documentService.updateAddDocumentActiveStatus(request).subscribe(
        (res) => {
          this.dialogRef.close({ data: 'you confirmed' });
        },
        (error) => {}
      )
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
